import React from 'react';
import FeedbacksContainer from './FeedbacksContainer';

const Feedbakcs = () => <FeedbacksContainer />;

export default Feedbakcs;
